module.exports = __webpack_public_path__ + "6a88dc4a0bf026b3055116f30f660804.png";